// extracted by mini-css-extract-plugin
export default {"p_tye":"_3ba865c95e","slcted":"_61837bafa8","slc_color":"b3c510ea0a","item_p":"_434ce7e6ca","r0":"_19aeb14592"};